import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  TrashIcon,
} from '@vgrubs/components';
import { WorkingHoursReponseV2 } from 'components/src/types/location.types';
import { Dispatch, SetStateAction } from 'react';

export const DeleteWorkingHours = ({
  modalIsOpen,
  closeModal,
  setWorkingHours,
}: PropsModal & {
  setWorkingHours: Dispatch<SetStateAction<WorkingHoursReponseV2>>;
  modalIsOpen: {
    index: number;
    type: 'business' | 'delivery';
  } | null;
  closeModal: () => void;
}) => {
  const { index, type } = modalIsOpen || {};

  async function handleDelete() {
    if (!index) return;

    setWorkingHours((prev) => {
      const filteredBusiness = prev?.business?.filter(
        (_, i) => i !== index - 1
      );
      const filteredDelivery = prev?.delivery?.filter(
        (_, i) => i !== index - 1
      );
      return {
        ...prev,
        business: type === 'business' ? filteredBusiness : prev.business,
        delivery: type === 'delivery' ? filteredDelivery : prev.delivery,
      } as WorkingHoursReponseV2;
    });

    closeModal?.();
  }

  return (
    <Modal isOpen={!!modalIsOpen} closeModal={closeModal} logo={false}>
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Working Hour?</H3>
      <P $mb="16">Are you sure you want to delete this working hour?</P>

      <Div $flex $gap="20px">
        <Div $width="50%">
          <Button $selected $w="100%" $mt="24" onClick={handleDelete}>
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button $selected $gray $w="100%" $mt="24" onClick={closeModal}>
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
